import { CandidateStatus } from 'domain/shared/candidate';
import ConvertCandidatePrompt from './ConvertCandidatePrompt';
import { useConversionRouteHelper } from 'domain/shared/employee';
import { CandidateDropdown } from 'domain/shared/candidate';

const ConvertCandidateDropdown = ({ source, ...props }: { source: string; label: string }) => {
  const { candidateId, setCandidateId } = useConversionRouteHelper();

  const onChangeCallback = (value: { [x: string]: any }) => {
    setCandidateId(value[source]);
  };

  const filter = {
    status: {
      eq: CandidateStatus.ACCEPTED,
    },
    convertedToEmployee: {
      NULL: true,
    },
  };

  return (
    <>
      <ConvertCandidatePrompt candidateId={candidateId!} />
      <CandidateDropdown
        {...props}
        source={source}
        onChangeCallback={onChangeCallback}
        value={candidateId}
        placeholder="Choose candidate"
        filter={filter}
      />
    </>
  );
};

export default ConvertCandidateDropdown;
